var _path, _path2, _line, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedback24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3C11.7675 3 8.84512 3 5.25069 3C3.59384 3 2.25 4.34315 2.25 6L2.25 13.8887C2.25 15.5456 3.59315 16.8887 5.25 16.8887L10.6229 16.8887C10.8809 16.8887 11.129 16.9884 11.3152 17.167L16.0289 21.6884C16.3467 21.9933 16.875 21.768 16.875 21.3276L16.875 16.8887L18.75 16.8887C20.4069 16.8887 21.75 15.5456 21.75 13.8887L21.75 10.5",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6967 2.11608C21.0133 1.43266 19.9053 1.43266 19.2219 2.11608L12.2197 9.11827L12 9.33794V9.6486V11.1893C12 11.8797 12.5596 12.4393 13.25 12.4393H14.7907H15.1014L15.321 12.2196L22.3232 5.21744C23.0066 4.53402 23.0066 3.42598 22.3232 2.74256L21.6967 2.11608ZM20.2825 3.17674C20.3802 3.07911 20.5384 3.07911 20.6361 3.17674L21.2626 3.80322C21.3602 3.90085 21.3602 4.05915 21.2626 4.15678L20.5203 4.89899L19.5403 3.91895L20.2825 3.17674ZM18.4797 4.97961L13.5 9.95926V10.9393H14.48L19.4597 5.95965L18.4797 4.97961Z",
    className: "filled",
    fill: "currentColor",
    strokeWidth: 0
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 8.25,
    x2: 11.25,
    y2: 8.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12H7.5",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.75,
    cy: 12,
    r: 0.75,
    className: "filled",
    fill: "currentColor",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback24);
export default __webpack_public_path__ + "static/media/Feedback-24.c1f4f800.svg";
export { ForwardRef as ReactComponent };